import React from 'react'
import { useSelector } from 'react-redux'
import get from 'lodash/get'

import { Text } from '@fielded/shared-ui'

import { selectFinances, selectPayables } from '../../../../root/reducers/retailer/finances'
import { isNewWalletViewAvailable, pluralize } from '../../../../van-shared/utils/utils'
import { getCategorizedPayables } from '../../../../root/reducers/retailer/finances/utils-new'
import { withUser } from '../../../../common/AuthenticationProvider'

// TODO: Wrap with withUser HOC only because the new wallet view is still gated by a feature flag.
//       Remove this once the feature is fully rolled out to production.
export const OverdueInfo = withUser(({ isPaused, config, user }) => {
  const finances = useSelector(selectFinances)
  const hasNewWalletView = isNewWalletViewAvailable(config, user)

  const overduePayments = get(finances, 'payables.overduePayments[0]')
  let overduePaymentsCount = overduePayments ? overduePayments.transactions.length : 0

  if (hasNewWalletView) {
    const payables = useSelector(selectPayables)
    const { overduePayables } = getCategorizedPayables(payables)
    overduePaymentsCount = overduePayables.length
  }

  const warningText = (
    <Text>
      Please note that your account will be blocked and deliveries suspended <Text tag='span' bold>if any payment is overdue</Text>. Pay immediately to avoid suspension of service.
    </Text>
  )

  const blockedText = (
    <Text>
      You have <Text tag='span' bold>{overduePaymentsCount} overdue {pluralize('payment', overduePaymentsCount)}.</Text>
    </Text>
  )

  return isPaused ? blockedText : warningText
})
